interface PartsKeyParams {
    key: string;
    universityIds: number[];
}

export const CompareQueryKey = {
    universities: (universityIds: number[]) => ['compare', universityIds],
    accommodation: (universityIds: number[]) => ['compare', 'accommodation', universityIds],
    parts: (params: PartsKeyParams) => ['compare', 'parts', params.key, params.universityIds],
};
